// extracted by mini-css-extract-plugin
module.exports = {"productCarousel":"hx-z","itemsContainer":"ix-z"};